<template>
  <div></div>
</template>

<script>
export default {
  name: 'AuthRedirect',
  created() {
    this.$store.commit('logout');
    document.location.href = this.$route.query.next;
  },
};
</script>
